export function sanitizeNumericInput(raw: string): string {
  return raw.replace(/[^\d.,]/g, '');
}

export function isDecimalInput(value: string): boolean {
  return /^(\d+([.,]\d*)?|[.,]\d+)?$/.test(value);
}

export function isIntegerInput(value: string): boolean {
  return /^\d*$/.test(value);
}
